import { lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import Layout from 'presentation/components/layout'
import { FooterLinkRoutes } from 'presentation/routes/publicPages/footerLinkRoutes/footerLinksRoutes'
import { AuthRoutes } from './authRoutes/authRoutes'
import { urlRoutes } from '../config/urlRoutes/urlRoutes'

const NotFound = lazy(() => import('presentation/pages/notFound404'))

export const publicRoutes = [...AuthRoutes, ...FooterLinkRoutes]

export default function PublicPages() {
  return (
    <Layout>
      <Routes>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<Navigate to={urlRoutes.public.auth.login.urlTo} replace />} />
        {publicRoutes.map((routes) => (
          <Route key={routes.path} path={routes.path} element={<routes.element />} />
        ))}
      </Routes>
    </Layout>
  )
}
